<div class="checkMFAStatusDialog">
  <h2 mat-dialog-title class="modal-title ">OTP Error</h2>
  <mat-dialog-content>
    <p>{{ errorMessage }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button class="primary-general-btn w-100 mt-0" matRipple (click)="closeDialog()">OK</button>
  </mat-dialog-actions>
</div>